export default "__VITE_ASSET__mQAvS1gO__"